var $ = require('jquery');

import {gsap} from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(function() {
    gsap.set($('.site-header').find('#menu-primary-navigation > .menu-item'), {
        opacity: 0,
        y: "15px",
    })
});

$(window).on('load', function() {
    // runs as soon as page loads
    navigationAnimation();
    customCursor();


    // scrollTrigger attached to these
    carouselAnimations();
    acfCardsAnimatation();
    searchPageAnimation();
    storyCardsAnimation();
});

function navigationAnimation() {
    var header = $('.site-header');
    var tl = gsap.timeline();
    window.scrollTo(0, 0);
    gsap.set(header.find('#menu-primary-navigation > .menu-item'), {
        opacity: 0,
        y: 10,
    })
    gsap.to('.init-animation-fadein', {
        opacity: 0,
        // duration: 0.28,
        duration: 0.40,
        delay: 0.75,
        onComplete: function() {
            
            $('.init-animation-fadein').remove();
            tl.play();
        }
    })
    tl.to('.site-header__logo', {
        opacity: 1,
        duration: 0.65,
    })
    if ( $(window).width() > 768 ) {
        tl.to(header.find('#menu-primary-navigation > .menu-item'), {
            stagger: 0.2,
            opacity: 1,
            y: 0,
            duration: 0.45,
            ease: "power1.out",
            clearProps: true,
        }, '-=0.05')
    }
    if ( $('.site-header__search-open').length > 0 ) {
        tl.to('.site-header__search-open', {
            opacity: 1,
            y: 0,
            duration: 0.45,
            ease: "power1.out",
        })
    }
    if ( $('.site-header__cta').length > 0 ) {
        tl.to('.site-header__cta', {
            opacity: 1,
            y: 0,
            duration: 0.45,
            ease: "power1.out",
            clearProps: true,
        }, '-=0.1')
    }
    tl.to('.site-header__login-menu', {
        opacity: 1,
        y: 0,
        duration: 0.45,
        ease: "power1.out",
        clearProps: true,
    }, '-=0.1');
    
    heroAnimation(tl);
}

function heroAnimation(tl) {
    if ( $('.hero-primary').length ) {
        tl.to('.hero-primary__background', {
            scale: 1.1,
            duration: 1.5,
            ease: "power1.out",
        }, '-=2')
        tl.to($('.hero-primary').find('.hero-primary__content'), {
            opacity: 1,
            duration: 0.53,
        }, '-=1.4');
    }
    if ( $('.hero-secondary').length ) {
        tl.to('.hero-secondary__visual-inner', {
            stagger: 0.2,
            y: 0,
            opacity: 1,
            duration: 0.5,
        }, '-=1')
    }
}

function customCursor() {
    let cursorItem = $('.custom-cursor');
    var sections = [{
            el :$('.tabs-and-content__tabs'),
            leafColor:  'green',
        }, {
            el: $('.dynamic-tabs__tabs'),
            leafColor: 'gray',
        }];

    $(window).on("mousemove", function(e) {
        let mouseX = e.clientX;
        let mouseY = e.clientY;
        gsap.to(cursorItem, {
            top: mouseY,
            left: mouseX,
            ease: "power2.out",
        })
    })

    sections.forEach(function(item, index) {
        // console.log(item);
        $(item.el).on('click', function() {
            gsap.fromTo($('.custom-cursor'), {
                scale: 0.8,
            }, {
                scale: 1,
            })
        })
        $(item.el).on("mouseenter", function(e) {
            $('.custom-cursor').addClass('bg-color--' + item.leafColor);
            gsap.to(cursorItem, {
                scale: 1,
                x: "-50%",
                y: "-50%",
                duration: 0.24,
            })
        })
    
        $(item.el).on("mouseleave", function(e) {
            $('.custom-cursor').removeClass('bg-color--' + item.leafColor);
            gsap.to(cursorItem, {
                scale: 0,
                x: "-50%",
                y: "-50%",
                duration: 0.24,
            })
        })
    })
}

function searchPageAnimation() {
    if ( $('.search-result').length ) {
        $('.search-result').each(function() {
            gsap.to(this, {
                scrollTrigger: {
                    trigger: this,
                    start: 'top 80%',
                },
                opacity: 1,
                y: 0,
                duration: 0.425,
            })
        })
    }
}

function carouselAnimations() {
    $('.carousel-cards').each(function() {
        let cards = $(this).find('.carousel-cards__card .carousel-cards__card-wrapper');
        let _this = $(this);
        fadeIn(_this, cards, true);
    })

    $('.carousel-slides').each(function() {
        let slides = $(this).find('.carousel-slides__card .carousel-slides__content-wrapper');
        let _this = $(this);
        fadeIn(_this, slides, true);
    })
    
    $('.carousel-media').each(function() {
        let media = $(this).find('.carousel-media__card .carousel-media__visual');
        let _this = $(this);
        fadeIn(_this, media, true);
    })
}

function storyCardsAnimation() {
    $('.post__related-posts').each(function() {
        let _this = $(this);
        let cards = $(this).find('.story-card');
        fadeIn(_this, cards, true);
    })
    $('.story-listing__stories').each(function() {
        let _this = $(this);
        let cards = $(this).find('.story-card');
        fadeIn(_this, cards, true);
    })
    $('.facetwp-template').each(function() {
        let _this = $(this);
        let cards = $(this).find('.story-card');
        fadeIn(_this, cards, true);
    })
}

function acfCardsAnimatation() {
    $('.container__cards').each(function() {
        let _this = $(this);
        let cards = $(this).find('.acf-card');
        fadeIn(_this, cards, true);
    })
}

function fadeIn( parent, elements, stagger ) {
    let items = elements;
    let _this = parent;
    gsap.to(items, {
        opacity: 1,
        y: 0,
        scrollTrigger: {
            trigger: _this,
            start: 'top 80%',
        },
        stagger: stagger ? 0.2 : false, 
        duration: 0.7,
    })
}